import React from "react";
import { Button, Modal } from "react-bootstrap";
import {AddServices} from "./AdminServices/AddServices";

export const AddServicesModal = ({company}) => {

    const [show, setShow] = React.useState(false);

    return (
        <React.Fragment>
            <Button onClick={() => setShow(!show)}>
                Lägg till Tjänst för {company}
            </Button>
            <Modal show={show}>

                <Modal.Body>
                    <AddServices company={company} />
                </Modal.Body>

                <Button
                onClick={() => setShow(false)}
                >
                    Stäng
                </Button>
            </Modal>
        </React.Fragment>
    )
}
